function cloneDeep(data) {
  return JSON.parse(JSON.stringify(data));
}

export default cloneDeep;
